module.exports = __webpack_public_path__ + "img/P24.0a9bf123.png";